import _slicedToArray from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { parseMetadata } from './responseInfo.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */

/**
 * Error parser for AWS JSON protocol.
 */

var parseJsonError = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var _ref2, _ref3, _response$headers$xA, _ref4, _body$message;

    var body, sanitizeErrorCode, code, message, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!response || response.statusCode < 300)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return parseJsonBody(response);

          case 4:
            body = _context.sent;

            sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
              var _rawValue$toString$sp = rawValue.toString().split(/[,:]+/),
                  _rawValue$toString$sp2 = _slicedToArray(_rawValue$toString$sp, 1),
                  cleanValue = _rawValue$toString$sp2[0];

              if (cleanValue.includes('#')) {
                return cleanValue.split('#')[1];
              }

              return cleanValue;
            };

            code = sanitizeErrorCode((_ref2 = (_ref3 = (_response$headers$xA = response.headers['x-amzn-errortype']) !== null && _response$headers$xA !== void 0 ? _response$headers$xA : body.code) !== null && _ref3 !== void 0 ? _ref3 : body.__type) !== null && _ref2 !== void 0 ? _ref2 : 'UnknownError');
            message = (_ref4 = (_body$message = body.message) !== null && _body$message !== void 0 ? _body$message : body.Message) !== null && _ref4 !== void 0 ? _ref4 : 'Unknown error';
            error = new Error(message);
            return _context.abrupt("return", Object.assign(error, {
              name: code,
              $metadata: parseMetadata(response)
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function parseJsonError(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Parse JSON response body to JavaScript object.
 */


var parseJsonBody = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
    var output;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (response.body) {
              _context2.next = 2;
              break;
            }

            throw new Error('Missing response payload');

          case 2:
            _context2.next = 4;
            return response.body.json();

          case 4:
            output = _context2.sent;
            return _context2.abrupt("return", Object.assign(output, {
              $metadata: parseMetadata(response)
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function parseJsonBody(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

export { parseJsonBody, parseJsonError };